$(function () {
  //console.log("custom-scripts loaded");

  // Account Buttons
  let jsRecoveryPasswordButton = document.querySelector('.js-recover-password');
  let cancelRecoverPasswordButtons = document.querySelectorAll('.cancel-recover-password');
  let jsCreateAccountButton = document.querySelector('.js-create-account');

  // Forms
  let loginForm = document.querySelector('#login');
  let createForm = document.querySelector('#create-account');
  let recoverForm = document.querySelector('#recover');

  if (jsRecoveryPasswordButton) {
    jsRecoveryPasswordButton.addEventListener('click', () => {
      loginForm.style.display = 'none';
      createForm.style.display = 'none';
      recoverForm.style.display = 'block';
    });
  }

  if (cancelRecoverPasswordButtons.length > 0) {
    cancelRecoverPasswordButtons.forEach(cancelRecoverPasswordButton => {
      cancelRecoverPasswordButton.addEventListener('click', () => {
        loginForm.style.display = 'block';
        createForm.style.display = 'none';
        recoverForm.style.display = 'none';
      });
    });
  }

  if (jsCreateAccountButton) {
    jsCreateAccountButton.addEventListener('click', () => {
      loginForm.style.display = 'none';
      createForm.style.display = 'block';
      recoverForm.style.display = 'none';
    });
  }

  // Keep Slider Working in the Admin
  function inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  if (inIframe()) {
    setInterval(function () {
      if ($(".announcement-slide").length >= 2) {
        $(".announcement-bar-slider").flickity({
          wrapAround: true,
          pageDots: false,
        });
      }
    }, 10);
  }

  if ($(".announcement-slide").length < 2) {
    $(".announcement-bar-slider").flickity("destroy");
  }

  // Collection Banner Description Limit
  /* make sure the word limit is an integer */
  const bannerWordLimit = parseInt(
    $(".collection-content").attr("data-word-limit"),
  );

  function wordLimit(limit, description) {
    let allWordsArray = description.split(" ");
    let contentLength = allWordsArray.length;

    if (contentLength < limit) {
      return $("#collection-description").html(description);
    } else {
      let clippedContent = "";
      if (limit == 1) {
        clippedContent = description.split(" ").splice(0, limit).join(" ");
      } else {
        clippedContent = description
          .split(" ")
          .splice(0, limit - 1)
          .join(" ");
      }
      let clippedReview = '<div class="clipped-review">';
      clippedReview += clippedContent;
      clippedReview += ' <span class="show-more">Read More</span></div>';

      let entireReview = '<div class="entire-review">';
      entireReview += description;
      entireReview += ' <span class="show-less">Show Less</span></div>';

      return $("#collection-description").html(clippedReview + entireReview);
    }
  }

  if (!$("main").hasClass("customer-service-page")) {
    /* Execute banner word limit function */
    if (!$(".banner__content ").hasClass("promo-collection")) {
      if ($("#hidden-description").val()) {
        let parentEle = $("#hidden-description").parent().parent();

        if (parentEle.hasClass("page-content")) {
          $("#page-description").html($("#hidden-description").val());
        } else if (parentEle.hasClass("collection-content")) {
          wordLimit(bannerWordLimit, $("#hidden-description").val());
        }
      }
    }
  }

  $(".show-more").click(function () {
    $(this).parent().parent().addClass("visible");
  });

  $(".show-less").click(function () {
    $(this).parent().parent().removeClass("visible");
  });
  /*
    // Collection Filter
    $('.open-column').click(function (e) {
        e.preventDefault();
        var _this = $(this);
        var target = this.hash;
        var $target = $(target);

        $('.open-side').not(this).removeClass('open-side');

        _this.toggleClass('open-side');
        $target.addClass('open-side');

        if (isScreenSizeLarge()) {
            $target.removeClass('animate__animated');
            $target.removeClass('animate__slideInLeft');
            $target.removeClass('animate__slideOutLeft');
            $target.removeClass('animate__slideInRight');
            $target.removeClass('animate__slideOutRight');

            if (_this.hasClass('open-side')) {
                $('.matrix__wrapper').addClass('smaller-grid');
                $('.container--no-products-in-collection').addClass('smaller-grid');
            } else {
                $('.matrix__wrapper').removeClass('smaller-grid');
                $('.container--no-products-in-collection').removeClass('smaller-grid');
                $target.removeClass('open-side');
            }
        } else {
            if (_this.hasClass('open-side')) {
                $('.matrix__wrapper').addClass('mobile-grid');
                $('.container--no-products-in-collection').addClass('mobile-grid');

                if (target == '#left-column') {
                    $target.addClass('animate__animated');
                    $target.addClass('animate__slideInLeft');
                    $target.removeClass('animate__slideOutLeft');
                } else {
                    $target.addClass('animate__animated');
                    $target.addClass('animate__slideInRight');
                    $target.removeClass('animate__slideOutRight');
                }
            } else {
                $('.matrix__wrapper').removeClass('mobile-grid');
                $('.container--no-products-in-collection').removeClass('mobile-grid');

                if (target == '#left-column') {
                    $target.addClass('animate__slideOutLeft');
                    $target.removeClass('animate__slideInLeft');
                } else {
                    $target.addClass('animate__slideOutRight');
                    $target.removeClass('animate__slideInRight');
                }
            }
        }
    });
*/

  // moving the collection sidebar into
  // a container inside the #left-column
  $(".collection-sidebar").appendTo(".filter-sections");

  // Product Page functions
  // add checked color to element on reload
  // Product Page / Quickview selected color text
  function updateSelectedColorText(swatchEl) {
    var $swatch = $(swatchEl);
    var colorName = $swatch.data("value") || $swatch.attr("aria-label");

    if (!colorName) return;

    var $fieldset = $swatch.closest("fieldset.swatch");

    if ($fieldset.length) {
      $fieldset.find(".options-selection__option-value.selected-color").html(colorName);
    } else {
      $swatch.closest(".product_form, .product-block, .quick-shop__popup")
        .find(".options-selection__option-value.selected-color")
        .first()
        .html(colorName);
    }
  }

  $(document)
    .off("click.selectedColor", ".swatch-element.color")
    .on("click.selectedColor", ".swatch-element.color", function () {
      updateSelectedColorText(this);
  });

  //store location slider
  $(".location-slider").flickity({
    pageDots: false,
  });

  //Customer Service
  $(".single-header").click(function () {
    var _this = $(this);
    var _thisContent = _this.siblings(".single-block-content");
    var otherHeaders = $(".single-header").not(_this);

    otherHeaders.removeClass("active");
    otherHeaders.siblings(".single-block-content").slideUp();

    _this.toggleClass("active");
    _thisContent.slideToggle();
  });

  // Fix mobile menu Golf text
  $('[data-mobile-menu-navlink-handle="golf-mobile"]')
    .children(".mobile-menu__first-level")
    .children(".submenu__label")
    .children("a")
    .text("Golf");
});
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/* Swatch Overflow Mobile */
document.addEventListener('DOMContentLoaded', function () {
  var selector = '.thumbnail-swatch.collapsed';
  var initialized = new WeakSet();

  function getRealSwatches(container) {
    return Array.from(container.children).filter(function (el) {
      return el.matches('a.swatch');
    });
  }

  function getGap(container) {
    var styles = window.getComputedStyle(container);
    return parseFloat(styles.columnGap || styles.gap || 0) || 0;
  }

  function getOuterWidth(el) {
    var styles = window.getComputedStyle(el);
    return (
      el.getBoundingClientRect().width +
      parseFloat(styles.marginLeft || 0) +
      parseFloat(styles.marginRight || 0)
    );
  }

  function getAvailableWidth(container) {
    var styles = window.getComputedStyle(container);
    return (
      container.clientWidth -
      parseFloat(styles.paddingLeft || 0) -
      parseFloat(styles.paddingRight || 0)
    );
  }

  function showAllSwatches(swatches) {
    swatches.forEach(function (swatch) {
      swatch.style.display = '';
    });
  }

  function hideSwatchesAfter(swatches, visibleCount) {
    swatches.forEach(function (swatch, index) {
      swatch.style.display = index < visibleCount ? '' : 'none';
    });
  }

  function setBadgeCount(badge, count) {
    var inner = badge.querySelector('.swatch-overflow-count__inner');
    if (inner) {
      inner.textContent = '+' + count;
    }
  }

  function getBadge(container) {
    var badge = container.querySelector(':scope > .swatch-overflow-count');

    if (!badge) {
      badge = document.createElement('button');
      badge.type = 'button';
      badge.className = 'swatch swatch__style--circle swatch-overflow-count';
      badge.setAttribute('aria-label', 'Show all color swatches');
      badge.innerHTML = '<span class="swatch-overflow-count__inner">+0</span>';

      badge.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        expandSwatches(container);
      });

      container.appendChild(badge);
    }

    return badge;
  }

  function clearBadge(badge) {
    badge.classList.remove('is-visible');
    badge.style.display = 'none';
    badge.style.visibility = '';
    setBadgeCount(badge, 0);
  }

  function resizeNearestFlickity(container) {
    var cell =
      container.closest('[class*="ai-product-slider__item-"]') ||
      container.closest('.flickity-slider > div');

    if (!cell) return;

    var flickityEl =
      cell.closest('[class*="ai-product-slider__track-"]') ||
      cell.closest('.flickity-enabled');

    if (!flickityEl) return;

    var viewport = flickityEl.querySelector('.flickity-viewport');

    function getFlickityInstance(el) {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        return window.Flickity.data(el);
      }

      if (window.jQuery) {
        var $el = window.jQuery(el);
        if ($el && typeof $el.data === 'function') {
          return $el.data('flickity');
        }
      }

      return null;
    }

    function applyHeight() {
      var newHeight = Math.ceil(cell.getBoundingClientRect().height);

      if (viewport && newHeight > 0) {
        viewport.style.height = newHeight + 'px';
      }

      var flkty = getFlickityInstance(flickityEl);
      if (flkty) {
        if (typeof flkty.reloadCells === 'function') {
          flkty.reloadCells();
        }
        if (typeof flkty.resize === 'function') {
          flkty.resize();
        }
        if (typeof flkty.reposition === 'function') {
          flkty.reposition();
        }
        if (typeof flkty.positionSlider === 'function') {
          flkty.positionSlider();
        }
      }
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        applyHeight();
        setTimeout(applyHeight, 50);
        setTimeout(applyHeight, 150);
        setTimeout(applyHeight, 300);
      });
    });
  }

  function expandSwatches(container) {
    var swatches = getRealSwatches(container);
    var badge = getBadge(container);

    container.classList.add('is-expanded');
    container.setAttribute('data-swatches-expanded', 'true');
    container.style.setProperty('--swatch-overflow-space', '0px');

    showAllSwatches(swatches);
    badge.classList.remove('is-visible');
    badge.style.display = 'none';

    resizeNearestFlickity(container);
  }

  function totalWidthWithoutBadge(widths, gap) {
    if (!widths.length) return 0;
    return widths.reduce(function (sum, width) {
      return sum + width;
    }, 0) + gap * (widths.length - 1);
  }

  function computeVisibleCount(widths, availableWidth, badgeWidth, gap) {
    var used = 0;
    var fit = 0;

    for (var i = 0; i < widths.length; i++) {
      var nextUsed = used + (fit > 0 ? gap : 0) + widths[i];
      var totalWithBadge = nextUsed + gap + badgeWidth;

      if (totalWithBadge <= availableWidth) {
        used = nextUsed;
        fit++;
      } else {
        break;
      }
    }

    return fit;
  }

  function renderCollapsedRow(container) {
    var swatches = getRealSwatches(container);
    var badge = getBadge(container);

    if (!swatches.length) return;

    if (container.getAttribute('data-swatches-expanded') === 'true') {
      expandSwatches(container);
      return;
    }

    container.classList.remove('is-expanded');

    showAllSwatches(swatches);
    clearBadge(badge);

    var availableWidth = getAvailableWidth(container);
    var gap = getGap(container);
    var swatchWidths = swatches.map(getOuterWidth);

    if (totalWidthWithoutBadge(swatchWidths, gap) <= availableWidth) {
      return;
    }

    var hiddenCount = 1;
    var visibleCount = swatches.length;
    var lastState = '';

    for (var i = 0; i < 10; i++) {
      setBadgeCount(badge, hiddenCount);
      badge.style.display = 'inline-flex';
      badge.style.visibility = 'hidden';

      var badgeWidth = getOuterWidth(badge);
      visibleCount = computeVisibleCount(swatchWidths, availableWidth, badgeWidth, gap);

      var newHiddenCount = swatches.length - visibleCount;
      var state = visibleCount + ':' + newHiddenCount + ':' + Math.round(badgeWidth);

      if (state === lastState) {
        hiddenCount = newHiddenCount;
        break;
      }

      lastState = state;
      hiddenCount = newHiddenCount;
    }

    if (hiddenCount <= 0) {
      clearBadge(badge);
      showAllSwatches(swatches);
      return;
    }

    hideSwatchesAfter(swatches, visibleCount);
    setBadgeCount(badge, hiddenCount);

    badge.style.visibility = '';
    badge.style.display = 'inline-flex';
    badge.classList.add('is-visible');

    container.appendChild(badge);

    var firstVisible = swatches.find(function (swatch) {
      return swatch.style.display !== 'none';
    });

    var firstRowTop = firstVisible ? firstVisible.offsetTop : badge.offsetTop;

    while (visibleCount > 0 && badge.offsetTop > firstRowTop + 1) {
      visibleCount--;
      hiddenCount++;

      hideSwatchesAfter(swatches, visibleCount);
      setBadgeCount(badge, hiddenCount);
      container.appendChild(badge);
    }
  }

  function initContainer(container) {
    renderCollapsedRow(container);

    if (initialized.has(container)) return;
    initialized.add(container);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        renderCollapsedRow(container);
      });
      ro.observe(container);
    }

    Array.from(container.querySelectorAll('img')).forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', function () {
          renderCollapsedRow(container);
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll(selector).forEach(initContainer);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 30);
  });

  initAll();
});